import { PAGE_PATH } from '@utilities/constants';
import { reloadPage, redirectToUrl } from '@utilities/utils';
import { useEffect } from 'react';

export const PAGE_RELOAD_KEY = `checkout_frontend_reload_pathname`;
const CHECKOUT_PATHS = new Set(Object.values(PAGE_PATH));

const isSafari = (): boolean => {
  const userAgent = navigator.userAgent;
  return /safari/i.test(userAgent) && !/chrome|crios|fxios|edgios|opera|opt\//i.test(userAgent);
};

/***
 * In some cases, specifically in Safari browsers, users may end up on an invalid checkout path (e.g., by using the back button) and sees a broken page.
 * In this scenario, we try to reload the page once to correct the URL.
 * If the path is still invalid after the page reload, we redirect the user to the cart page to avoid an infinite loop.
 ***/
export const useCheckoutPathValidator = () => {
  useEffect(() => {
    if (!isSafari()) {
      return;
    }

    const currentPath = window.location.pathname;

    if (CHECKOUT_PATHS.has(currentPath)) {
      sessionStorage.removeItem(PAGE_RELOAD_KEY);
      return;
    }

    const hasReloadedBefore = sessionStorage.getItem(PAGE_RELOAD_KEY);

    if (!hasReloadedBefore) {
      sessionStorage.setItem(PAGE_RELOAD_KEY, 'true');
      reloadPage();
    } else {
      sessionStorage.removeItem(PAGE_RELOAD_KEY);
      redirectToUrl(PAGE_PATH.CART);
    }
  }, []);
};
